import { ColumnsType } from 'antd/lib/table'
import formatNumber from '../../../../../../../helpers/formatters/format-any-number'
import renderDate from '../../../../../../../helpers/tables/render-date'
import RewindQueueEntry from '../../../../../../../types/api/rewind-queue-entry'
import ShipmentPosition from '../../../../../../../types/api/shipment-position'
import { MaterialColumnCell } from '../../../../../flexo/components/cells/material-column-cell'
import ActionsCell from './actions-cell'

export const columns: ColumnsType<RewindQueueEntry> = [
    {
        dataIndex: ['rewind_job', 'id'],
        title: 'Номер',
        width: 60,
        render: value => value || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'clientDeliveryDate'],
        title: 'Дата поставки',
        width: 70,
        render: (_value, record) => {
            const clientDeliveryDate = record.rewind_job?.shipment?.clientDeliveryDate

            return clientDeliveryDate ? renderDate(clientDeliveryDate) : '—'
        },
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'client', 'name'],
        title: 'Заказчик',
        render: (_value, record) => record.rewind_job?.shipment?.client?.name || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'shipment_positions'],
        title: 'Тираж',
        render: (_value: ShipmentPosition[], record) =>
            formatNumber(
                (record.rewind_job?.shipment?.shipment_positions || []).reduce(
                    (acc, position) => acc + (position.copies || 0),
                    0
                )
            ),
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'materialRequirements'],
        title: 'Материал',
        width: 100,
        render: (_value, record) => (
            <MaterialColumnCell value={record.rewind_job?.shipment?.materialRequirements || []} />
        ),
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'bushing'],
        title: 'Втулка',
        width: 70,
        render: (_value, record) => record.rewind_job?.shipment?.bushing || '—',
    },
    {
        dataIndex: 'actions',
        title: '',
        fixed: 'right',
        render: (_value, record) => <ActionsCell rewindQueueEntry={record} />,
    },
]
